import { IPmFormConducting } from '../../../APIPackage/CatalogsModule/interfaces/IPmFormConducting';
import { IPmFormConductingSelectOption } from '../interfaces/IPmFormConductingSelectOption';

export function createPmFormConductingSelectOption(pmForm: IPmFormConducting): IPmFormConductingSelectOption {
  return {
    ...pmForm,
    label: pmForm.title,
    value: pmForm.id,
  };
}
